import type { TOC } from '@ember/component/template-only';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface GeneralListsContentCategoryNameSignature {
  Args: {
    category: unknown;
    isLoading?: boolean;
  };
}

const GeneralListsContentCategoryName = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="category-name-container flex items-center gap-100">
    {{#if @isLoading}}
      <div class="parity-section-loading-bar-container">
        <div class="table-loading-state-bar"></div>
      </div>
    {{else}}
      <div class="category-name truncate">
        {{@category.name}}
      </div>
      <GeneralIconWithTooltip
        @side="top"
        @size="small"
        @tooltipContent={{@category.message}}
      />
    {{/if}}
  </div>
</template> satisfies TOC<GeneralListsContentCategoryNameSignature>;

export default GeneralListsContentCategoryName;
